<template>
  <main class="public-application-page">
    <div class="public-application-page__background" aria-hidden="true"></div>

    <div class="public-application-page__shell">
      <header v-if="Business" class="public-application-brand">
        <div class="public-application-brand__identity">
          <div class="public-application-brand__logo">
            <img v-if="Business.imageUrl" :src="Business.imageUrl" :alt="`${Business.name || 'Organization'} logo`" />
            <span v-else>{{ businessInitials }}</span>
          </div>
          <div>
            <div class="public-application-brand__eyebrow">Enrollment application</div>
            <h1>{{ Business.name || "Student enrollment" }}</h1>
            <p>Complete the form below and our team will follow up with you.</p>
          </div>
        </div>

        <div v-if="Business.phoneNumber || businessAddress" class="public-application-brand__contact">
          <span v-if="Business.phoneNumber">
            <v-icon size="16">mdi-phone-outline</v-icon>
            {{ Business.phoneNumber | USPhoneNumber }}
          </span>
          <span v-if="businessAddress">
            <v-icon size="16">mdi-map-marker-outline</v-icon>
            {{ businessAddress }}
          </span>
        </div>
      </header>

      <div v-if="!Business" class="public-application-loading" role="status">
        <v-progress-circular indeterminate color="primary" size="34" />
        <span>Loading application…</span>
      </div>

      <NewApplication v-else :currentBusiness="Business" :takeCard="true" />
    </div>
  </main>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
import NewApplication from "@/modules/Application/components/NewApplication.vue"
export default {
  name: 'remote-application',
  components: {
    NewApplication
  },
  data() {
    return {
      Business: null,
    } 
  },
  computed: {
    businessInitials() {
      if (!this.Business || !this.Business.name) return "T";
      return this.Business.name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word.charAt(0))
        .join("")
        .toUpperCase();
    },
    businessAddress() {
      if (!this.Business) return "";
      return [
        this.Business.address,
        this.Business.city,
        this.Business.state,
        this.Business.zip,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },
  created() {
    this.loadBusiness()
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.id;
      console.log("id", id);
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          this.StripeKey = this.Business.metadata.publicStripeId;
          this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error", error);
          this.$router.push({ name: "pagenotfound" });
        });
    }
  }
  
}
</script>

<style scoped>
.public-application-page {
  position: relative;
  min-height: 100vh;
  overflow-x: clip;
  padding: 28px 16px 42px;
  background: #f5f8f5;
}

.public-application-page__background {
  position: absolute;
  z-index: 0;
  top: -180px;
  right: -140px;
  width: 440px;
  height: 440px;
  border-radius: 50%;
  opacity: .8;
  background: radial-gradient(circle, #dcefe0 0%, rgba(220, 239, 224, 0) 70%);
  pointer-events: none;
}

.public-application-page__shell {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

.public-application-brand {
  overflow: hidden;
  margin-bottom: 18px;
  border: 1px solid #dfe8e1;
  border-radius: 18px;
  background: rgba(255, 255, 255, .96);
  box-shadow: 0 14px 35px rgba(42, 72, 50, .08);
}

.public-application-brand__identity {
  display: flex;
  gap: 16px;
  padding: 22px 24px 18px;
  align-items: center;
}

.public-application-brand__logo {
  display: flex;
  overflow: hidden;
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce9df;
  border-radius: 16px;
  color: #2f7d4a;
  background: #eef7f0;
  font-size: 20px;
  font-weight: 800;
}

.public-application-brand__logo img {
  width: 100%;
  height: 100%;
  padding: 7px;
  object-fit: contain;
}

.public-application-brand__eyebrow {
  color: #2f7d4a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .1em;
  text-transform: uppercase;
}

.public-application-brand h1 {
  margin: 3px 0 2px;
  color: #223128;
  font-size: 24px;
  line-height: 1.2;
}

.public-application-brand p {
  margin: 0;
  color: #718078;
  font-size: 13px;
}

.public-application-brand__contact {
  display: flex;
  gap: 18px;
  padding: 11px 24px;
  border-top: 1px solid #e8eee9;
  color: #647169;
  background: #fafcfb;
  font-size: 11px;
}

.public-application-brand__contact span {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.public-application-loading {
  display: flex;
  min-height: 320px;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  justify-content: center;
  color: #6f7d74;
}

@media (max-width: 599px) {
  .public-application-page {
    padding: 12px 10px 28px;
  }

  .public-application-brand {
    margin-bottom: 12px;
    border-radius: 15px;
  }

  .public-application-brand__identity {
    gap: 12px;
    padding: 16px 14px 14px;
    align-items: flex-start;
  }

  .public-application-brand__logo {
    width: 52px;
    height: 52px;
    flex-basis: 52px;
    border-radius: 13px;
    font-size: 16px;
  }

  .public-application-brand h1 {
    font-size: 19px;
  }

  .public-application-brand p {
    margin-top: 4px;
    font-size: 11px;
    line-height: 1.45;
  }

  .public-application-brand__contact {
    flex-direction: column;
    gap: 7px;
    padding: 10px 14px;
  }
}
</style>
